import { render, staticRenderFns } from "./HTTPError.vue?vue&type=template&id=6780e733&scoped=true&"
import script from "./HTTPError.vue?vue&type=script&lang=ts&"
export * from "./HTTPError.vue?vue&type=script&lang=ts&"
import style0 from "./HTTPError.vue?vue&type=style&index=0&id=6780e733&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6780e733",
  null
  
)

export default component.exports